"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Grid = function (_a) {
    var dusk = _a.dusk, className = _a.className, gridClassName = _a.gridClassName, children = _a.children, _b = _a.size, size = _b === void 0 ? 'base' : _b;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: className },
        react_1.default.createElement("div", { className: classnames_1.default('flex', gridClassName, {
                '-mx-3': size === 'base',
                '-mx-6': size === 'lg',
            }) }, children)));
};
exports.default = Grid;
//# sourceMappingURL=Grid.js.map